/* Round 25f · U1 — readable framework names; internal codes ("full", "sme", "rf / pf") never reach the screen. */

const SME_ED = (periodStart) => ((periodStart || "") >= "2027-01-01" ? "2025" : "2015");

/** One part: "full" | "sme" | "IAS 1" | "IFRS 18" | "rf / pf" | "sme2015" … → readable, EN/AR via t. */
export function fwName(t, key, periodStart) {
  const raw = String(key || "").trim();
  if (!raw) return "—";
  if (raw.includes("/")) {
    const [rf, pf] = raw.split("/").map((s) => s.trim());
    return fwName(t, rf === "sme" ? "sme" : `full|${pf}`, periodStart);
  }
  if (raw === "sme" || raw.startsWith("sme20")) return t("fwName.sme").replace("{ed}", raw.startsWith("sme20") ? raw.slice(3) : SME_ED(periodStart));
  if (raw.startsWith("full|")) return t("fwName.full").replace("{pf}", raw.slice(5) || "IAS 1");
  if (raw === "full" || raw === "ias1") return t("fwName.full").replace("{pf}", "IAS 1");
  if (raw === "ifrs18") return t("fwName.full").replace("{pf}", "IFRS 18");
  if (raw === "IAS 1" || raw === "IFRS 18") return t("fwName.pfOnly").replace("{pf}", raw);
  return raw;
}
